import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { CertificateSection } from './components/certificate-section';
import { ModuleCompletionTable } from './components/module-completion-table';
import { ProgressOverview } from './components/progress-overview';

import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useEnrichedProgress } from '@/hooks/use-training-progress';


export function ProgressPage() {
  const { data: progress, isLoading } = useEnrichedProgress();

  if (isLoading) {
    return (
      <div className="mx-auto max-w-3xl space-y-6">
        <Skeleton className="h-64" />
        <Skeleton className="h-48" />
      </div>
    );
  }

  if (!progress) return null;

  const nextModule = progress.modules.find((m) => m.status === 'not_started');

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <h1 className="text-2xl font-bold">Progress Dashboard</h1>

      <ProgressOverview progress={progress} />

      <CertificateSection progress={progress} />

      {nextModule && (
        <div className="flex justify-center">
          <Button asChild>
            <Link to={`/training/modules/${nextModule.module_id}`}>
              Continue Training
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      )}

      <div className="rounded-lg border">
        <ModuleCompletionTable modules={progress.modules} />
      </div>
    </div>
  );
}
